import {
  Box, Button, Input, Modal, ModalBody, ModalCloseButton,
  ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Text, useDisclosure,
} from "@chakra-ui/react";
import { useEffect, useState, useReducer } from "react";
import { useAuth } from "../../../Hooks/useAuth";
import { api } from "../../../services/api";
import swal from "sweetalert";

const GREEN  = "#004a33";
const ORANGE = "#fc8f04";

function FormField({ label, children }) {
  return (
    <Box mb="14px">
      <Text fontSize="11px" fontWeight="700" color="gray.500" mb="5px" textTransform="uppercase" letterSpacing="0.05em">
        {label}
      </Text>
      {children}
    </Box>
  );
}

const inputProps = {
  borderRadius: "8px",
  fontSize: "14px",
  bg: "white",
  border: "1px solid rgba(0,74,51,.2)",
  _focus: { borderColor: GREEN, boxShadow: `0 0 0 1px ${GREEN}` },
};

export function EditProductType({ productTypeId, thisProductType, allCategories, allDrinkCategories, onUpdateProductType }) {
  const { user } = useAuth();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [productType, setProductType] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    { name: "", categoryId: "", eventDrinkCategory: "" }
  );
  const [categories] = useState(allCategories);
  const drinkCategories = allDrinkCategories || [];

  useEffect(() => {
    if (!thisProductType) return;
    setProductType({
      name: thisProductType.name || "",
      categoryId: thisProductType.category_id || "",
      eventDrinkCategory: thisProductType.event_drink_category || "",
    });
  }, [thisProductType]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProductType({ [name]: value });
  };

  async function handleSave(e) {
    e.preventDefault();
    if (productType.categoryId === "") {
      swal({ title: "Atenção", text: "Escolha uma categoria.", icon: "info" });
      return;
    }
    const formData = new FormData();
    formData.append("product_type[name]", productType.name);
    formData.append("product_type[category_id]", productType.categoryId);
    formData.append("product_type[event_drink_category]", productType.eventDrinkCategory);
    const response = await api.put(`/api/v1/product_types/${productTypeId}`, formData, {
      headers: { "access-token": user.token, client: user.client, uid: user.uid, accept: "application/json", contentType: "multipart/form-data" },
    });
    if (response.status === 200) {
      onUpdateProductType(response.data);
      swal({ title: "Atualizado!", text: "Tipo atualizado com sucesso.", icon: "success" });
      onClose();
    } else {
      swal({ title: "Erro", text: "Algo deu errado.", icon: "error" });
      onClose();
    }
  }

  return (
    <>
      <Button
        size="xs" borderRadius="7px" px="10px" h="26px"
        bg={GREEN} color={ORANGE} fontWeight="700" fontSize="11px"
        _hover={{ opacity: 0.85 }} onClick={onOpen}
      >
        Editar
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay bg="rgba(0,0,0,.45)" backdropFilter="blur(2px)" />
        <ModalContent borderRadius="16px" overflow="hidden" mx="16px">
          <ModalHeader bg={GREEN} py="14px" px="20px" pr="44px">
            <Text fontSize="15px" fontWeight="800" color={ORANGE}>Editar Tipo de Produto</Text>
            <Text fontSize="11px" color="rgba(255,255,255,.45)" fontWeight="500" mt="1px">#{productTypeId}</Text>
          </ModalHeader>
          <ModalCloseButton color="rgba(255,255,255,.6)" _hover={{ color: "white", bg: "transparent" }} top="12px" right="14px" />
          <ModalBody px="20px" py="20px" bg="#fafbfc">
            <FormField label="Nome">
              <Input value={productType.name} placeholder="Nome do tipo" name="name" onChange={handleChange} {...inputProps} />
            </FormField>
            <FormField label="Categoria">
              <Select value={productType.categoryId} name="categoryId" onChange={handleChange} {...inputProps}>
                <option value="">Selecione a categoria</option>
                {categories.map(cat => (
                  <option key={cat.id} value={cat.id}>{cat.name}</option>
                ))}
              </Select>
            </FormField>
            <FormField label="Categoria da calculadora de eventos">
              <Select value={productType.eventDrinkCategory} name="eventDrinkCategory" onChange={handleChange} {...inputProps}>
                <option value="">Nenhuma / não aplicável</option>
                {drinkCategories.map(dc => (
                  <option key={dc.key} value={dc.key}>{dc.label}</option>
                ))}
              </Select>
            </FormField>
          </ModalBody>
          <ModalFooter bg="white" borderTop="1px solid rgba(0,74,51,.08)" px="20px" py="12px" gap="8px" justifyContent="flex-end">
            <Button size="sm" variant="ghost" colorScheme="gray" borderRadius="8px" onClick={onClose}>Cancelar</Button>
            <Button size="sm" bg={GREEN} color={ORANGE} borderRadius="8px" px="16px" fontWeight="700" fontSize="12px" _hover={{ opacity: 0.88 }} onClick={handleSave}>
              Salvar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
